import { render, staticRenderFns } from "./beneficiaryAdditionalInformation.vue?vue&type=template&id=6974f246&"
import script from "./beneficiaryAdditionalInformation.vue?vue&type=script&lang=js&"
export * from "./beneficiaryAdditionalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports